export enum PdfExportType {
    Dashboard,
    Report,
    SingleChart,
    DashboardPortrait,
    MultiPageDashboard
}
